import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function BridgePage() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <div className="min-h-screen w-full bg-[#f8f4ed] text-[#2a2a2a] overflow-x-hidden" style={{
    fontFamily: "'Inter', sans-serif"
  }} data-id="element-2">
      <main className="max-w-2xl mx-auto px-6 py-20 md:py-32 flex flex-col items-center" data-id="element-3">
        <motion.article initial="hidden" animate="visible" variants={containerVariants} className="w-full flex flex-col items-center text-center space-y-10 md:space-y-12" data-id="element-4">
          {/* 1. HEADLINE */}
          <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl leading-[1.2] md:leading-[1.15] text-[#1a1a2e] font-medium max-w-xl" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-5">
            Cuando haces mucho…
            <span className="block mt-2 md:mt-3 italic text-[#b8943e]/90" data-id="element-6">
              pero la mente sigue activa
            </span>
          </motion.h1>

          {/* 2. PARAGRAPH 1 */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl leading-relaxed text-[#2a2a2a]/90 max-w-lg font-light" data-id="element-7">
            El día avanza, cumples con lo que toca y, cuando todo se calma,
            aparece ese diálogo interno que no siempre sabe cuándo parar.
          </motion.p>

          {/* 3. PARAGRAPH 2 */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl leading-relaxed text-[#2a2a2a]/90 max-w-lg font-light" data-id="element-8">
            No es falta de esfuerzo. Es una forma habitual de procesar
            exigencias, pensamientos y expectativas.
          </motion.p>

          {/* 4. IMAGE */}
          <motion.div variants={itemVariants} className="w-full max-w-lg my-4" data-id="element-9">
            <div className="relative rounded-xl overflow-hidden shadow-xl shadow-[#b8943e]/10 bg-[#eaddcf]" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/gJRuWHDGgNsY4VoZbZ6HjT/fot_para_la_pagina_puente_1.png" alt="Mujer leyendo la guía Silencia a Mamá Juez en una tablet, en un ambiente cálido y acogedor" className="w-full h-auto object-cover" width={800} height={533} loading="eager" decoding="async" data-id="element-11" />
            </div>
          </motion.div>

          {/* 5. PARAGRAPH 3 */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl leading-relaxed text-[#2a2a2a] max-w-lg font-medium" data-id="element-12">
            Hoy existen enfoques prácticos para entender cómo funciona ese
            diálogo interno, sin pelear contigo ni entrar en procesos largos.
          </motion.p>

          {/* 5b. PARAGRAPH 4 */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl leading-relaxed text-[#2a2a2a]/90 max-w-lg font-light" data-id="element-13">
            Esta guía propone una forma clara y cotidiana de observarlo y
            trabajar con él, desde la calma y el ritmo real.
          </motion.p>

          {/* 5c. PARAGRAPH 5 */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl leading-relaxed text-[#2a2a2a] max-w-lg font-medium" data-id="element-14">
            Si te reconoces en esto, no necesitas motivación.
            <br data-id="element-15" />
            Necesitas entender qué está pasando en tu cabeza… sin atacarte.
          </motion.p>

          {/* 6. CTA BUTTON */}
          <motion.div variants={itemVariants} className="pt-4" data-id="element-16">
            <a href="https://mamajuez.narelaspace.com/" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-[#1a1a2e] bg-[#b8943e] rounded-full overflow-hidden transition-all duration-300 hover:bg-[#a68536] hover:shadow-lg hover:shadow-[#b8943e]/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#b8943e] focus:ring-offset-[#f8f4ed]" data-id="element-17">
              <span className="relative z-10 flex items-center gap-2" data-id="element-18">
                Conocer cómo funciona
                <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-19" />
              </span>
            </a>
          </motion.div>

          {/* 7. FOOTER LINE */}
          <motion.div variants={itemVariants} className="pt-8 border-t border-[#2a2a2a]/10 w-full max-w-xs mx-auto" data-id="element-20">
            <p className="text-sm text-[#2a2a2a]/60 font-medium tracking-wide uppercase text-center" data-id="element-21">
              Guía práctica · 10 minutos al día · ritmo real
            </p>
          </motion.div>
        </motion.article>
      </main>
    </div>;
}